import { Component } from 'react';
import {connect} from 'react-redux';
import {delinkOutlet, getAdminOutlets} from '../../../actions/outlet';
import PageTitle from '../../common/page-title';
import OutletSearch from './outlet-search';
import OutletTable from './outlet-table';

class OutletList extends Component {
  state = {
    query: '',
    pageNumber: 1
  };

  handlePageChange = (page) => {
    this.setState({ pageNumber: page }, this.afterPageChange);
  };

  afterPageChange = () => {
    const { query, pageNumber } = this.state;

    this.props.dispatch(getAdminOutlets(query, pageNumber));
  };

  UNSAFE_componentWillMount() {
    this.getOutlets();
  }

  getOutlets(query = '', pageNumber = '') {
    const {dispatch} = this.props;

    dispatch(getAdminOutlets(query, pageNumber))
      .then(() => {
        this.setState({
          pageNumber: 1
        });
      });
  }

  handleChange(event) {
    this.setState({query: event.target.value});
  }

  handleClear() {
    this.setState({
      query: '',
      pageNumber: 1
    });
    this.getOutlets();
  }

  handleSearch() {
    this.getOutlets(this.state.query);
  }

  delinkOutlet(id) {
    const {dispatch} = this;
    dispatch(delinkOutlet(id));
  }

  render() {
    const {query, pageNumber} = this.state;
    const {outlets, paging, fetched} = this.props;


    return (
      <div className="container-fluid">
        <PageTitle>
          Outlets
        </PageTitle>
        <OutletSearch
          onChange={event => this.handleChange(event)}
          onClear={() => this.handleClear()}
          onSearch={event => this.handleSearch(event)}
          searchValue={query}
        />
        { fetched && (
          <OutletTable
            currentPage={pageNumber}
            handleDelink={this.delinkOutlet}
            onPageChange={this.handlePageChange}
            outlets={outlets}
            paging={paging}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  outlets: state.stores.stores,
  fetched: state.stores.fetched,
  paging: state.stores.paging
});

export default connect(mapStateToProps)(OutletList);
